import React from 'react';

import {Text} from '@albert-io/atomic';

import {AdaptiveSkillPathsCard} from '../cards/AdaptiveSkillPathsCard';
import {BrowseSubjectsTile, CreateAssignmentTile} from '../cards/homeTiles';

/** No-classes "just exploring" paths: adaptive skill paths (personalized) + assignment + browse. */
export const JustExploringSection = () => (
  <section
    aria-label='Just exploring'
    className='gap-x2 rounded-x3 background-primary p-x5 flex flex-col'
  >
    <Text size='l'>Just exploring?</Text>
    <AdaptiveSkillPathsCard />
    <div className='gap-x2 s:grid-cols-2 grid grid-cols-1'>
      <CreateAssignmentTile horizontal />
      <BrowseSubjectsTile horizontal />
    </div>
  </section>
);
